var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.groupClass},[_c('GlyphSortButtonGroup'),_c('GlyphProtectedRowButtonGroup'),_c('GlyphAutosortButtonGroup'),_c('GlyphCleanButtonGroup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }